import React, { Component } from "react";
import { wsocket } from "WEBSOCKET/wsocket";
import { getMessage } from "CONFIG/i18n";
import { COMPONENT_IN_FOCUS} from "../../Utils/Constants";
import ic_screen_inactive from "ASSETS/Images/header_center/ic_share_white.svg";
import "./ScreenShare.less";

export default class ScreenShareSide extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (!wsocket.io) return;
    this.setMediaStream();
    this.setShareFrameDimensions();
  }

  setMediaStream = () => {
    const ssVideo = document.getElementById(this.props.screenShareId);
    ssVideo.srcObject = this.props.screen;
  };

  setShareFrameDimensions = () => {
    const screenShare = document.getElementById(this.props.screenShareId);
    const screenShareFrame = document.getElementsByClassName("fullScreenDiv");
    const cardBodySide = document.getElementById(`${this.props.screenShareId + "CardBody"}`);
    
    if (!screenShare && !screenShareFrame && !cardBodySide) {
      return;
    }
    cardBodySide.style.width = "100%";
    if (this.props.screenShareId !== "screenshareMobile") {
      cardBodySide.style.position = "relative";
      cardBodySide.style.aspectRatio = 16 / 9;
    }

    screenShare.style.width = "100%";
    screenShare.style.height = "100%";
    screenShare.style.top = "50%";
    screenShare.style.left = "50%";
    screenShare.style.transform = `translate(-50%,-50%) scale(1.0)`;
    screenShare.style.transformOrigin = "50% 0%";
    screenShare.style.position = "absolute";
  }

  toggleScreenSharingState = () => {
    if(this.props.showCustomerCoBrowse || this.props.showSnapshot || (this.props.snapshoteeId && this.props.snapshotPermissionReply)) return;
    if (this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO || this.props.componentInFocus == COMPONENT_IN_FOCUS.INBOUND_COBROWSE) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    }
    this.props.setValue("isZoomOut", false);
  }
  
  render() {
    return (
      <div id={this.props.screenShareId + "CardBody"} className="cardBody ssDiv1"
        onClick={() => this.toggleScreenSharingState()}>
        <div className="screenShareSideHeading">
          <img src={ic_screen_inactive} className="iconScreenShare" />
          <label className="title"> {getMessage("SCREENSHARE")} </label>
        </div>
        <div className={this.props.screenShareId === "screenshareMobile" ? "fullScreenDiv fullScreenDiv-mobile" : "fullScreenDiv"} style={{ width: "100%", height: "100%" }}>
          <video
            id={this.props.screenShareId}
            className="screenShareVideo"
            muted={true}
            autoPlay
            playsInline
            disablePictureInPicture
          />
        </div>
      </div>
    );
  }
}
